var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: { loading: _vm.loading, color: _vm.$constants.LOADING_COLOR },
      }),
      _vm._v(" "),
      !_vm.loading && _vm.records && _vm.records.length
        ? _c(
            "div",
            [
              _vm._l(_vm.records, function (r) {
                return _c("div", { staticClass: "card m-2 shadow-sm" }, [
                  _c("div", { staticClass: "card-body p-2" }, [
                    _c(
                      "div",
                      { staticClass: "flex pl-2 mb-1 justify-content-between" },
                      [
                        _c("h5", { staticClass: "mb-0" }, [
                          _c("strong", [_vm._v(_vm._s(r.title))]),
                          _vm._v(" "),
                          _c("span", { staticClass: "text-muted fs-11" }, [
                            _vm._v(_vm._s(_vm.printDate(r.created_at))),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex" },
                          [
                            _vm.$can("updateDrugStatusPrices")
                              ? _c("LoadingButton", {
                                  attrs: {
                                    title: "Отклонить",
                                    className: "btn btn-outline-warning",
                                    onClick: () =>
                                      _vm.acceptTask(
                                        _vm.sTasks[r.id]?.id,
                                        "reject"
                                      ),
                                    loading:
                                      _vm.btnLoading[_vm.sTasks[r.id]?.id],
                                    color: _vm.$constants.SUCCESS_COLOR,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.$can("updateDrugStatusPrices")
                              ? _c("LoadingButton", {
                                  attrs: {
                                    title: "Подтвердить",
                                    className: "btn btn-success",
                                    onClick: () =>
                                      _vm.acceptTask(
                                        _vm.sTasks[r.id]?.id,
                                        "accept"
                                      ),
                                    loading:
                                      _vm.btnLoading[_vm.sTasks[r.id]?.id],
                                    color: _vm.$constants.SUCCESS_COLOR,
                                  },
                                })
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "mb-2 p-2" },
                      [
                        false
                          ? _c("p", { staticClass: "mb-0" }, [
                              _vm._v("Новые цены выделены зеленым"),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        false
                          ? [
                              _c("SingeProjectPriceChanges", {
                                attrs: { record: _vm.getSingleTask(r.id) },
                              }),
                              _vm._v(" "),
                              _vm.localTasks[r.id].length > 2
                                ? [
                                    _c(
                                      "v-popover",
                                      {
                                        attrs: {
                                          popoverClass:
                                            "drug_changes_tasks_popover",
                                          popoverInnerClass:
                                            "drug_changes_tasks_popover",
                                          placement: "bottom",
                                          trigger: "hover",
                                          delay: { show: 150, hide: 150 },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "badge badge-info" },
                                          [
                                            _vm._v(
                                              "Всего " +
                                                _vm._s(
                                                  _vm.localTasks[r.id].length
                                                ) +
                                                " изменений"
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("template", { slot: "popover" }, [
                                          _c(
                                            "table",
                                            {
                                              staticClass:
                                                "table mt-1 table-sm table-hover change_table",
                                            },
                                            [
                                              _c("thead", [
                                                _c("tr", [
                                                  _c("th", [_vm._v("Проект")]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v("Изменения"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c("th", [
                                                    _vm._v("Фактически"),
                                                  ]),
                                                ]),
                                              ]),
                                              _vm._v(" "),
                                              _c(
                                                "tbody",
                                                _vm._l(
                                                  _vm.localTasks[r.id],
                                                  function (t, i) {
                                                    return t
                                                      ? _c("tr", [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm
                                                                  .$AllProjects[
                                                                  t.task
                                                                    .project_id
                                                                ]?.title
                                                              )
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      "btn btn-outline-primary": true,
                                                                      active:
                                                                        +t.task
                                                                          .is_active,
                                                                    },
                                                                  },
                                                                  [_vm._v("A")]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      "btn btn-outline-primary": true,
                                                                      active:
                                                                        +t.task
                                                                          .order_allow,
                                                                    },
                                                                  },
                                                                  [_vm._v("З")]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "price_span",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "кол. "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            t
                                                                              .task
                                                                              .qty
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      ": "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            t
                                                                              .task
                                                                              .price
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " (" +
                                                                        _vm._s(
                                                                          _vm.getProfitPercent(
                                                                            r,
                                                                            t
                                                                              .task
                                                                              .price
                                                                          )
                                                                        ) +
                                                                        "%)"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "flex",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      "btn btn-outline-primary": true,
                                                                      active:
                                                                        +t
                                                                          .actualData
                                                                          .is_active,
                                                                    },
                                                                  },
                                                                  [_vm._v("A")]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    class: {
                                                                      "btn btn-outline-primary": true,
                                                                      active:
                                                                        +t
                                                                          .actualData
                                                                          .order_allow,
                                                                    },
                                                                  },
                                                                  [_vm._v("З")]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "price_span",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "кол. "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            t
                                                                              .actualData
                                                                              .qty
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      ": "
                                                                    ),
                                                                    _c(
                                                                      "strong",
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            t
                                                                              .actualData
                                                                              .price
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _vm._v(
                                                                      " (" +
                                                                        _vm._s(
                                                                          _vm.getProfitPercent(
                                                                            r,
                                                                            t
                                                                              .actualData
                                                                              .price
                                                                          )
                                                                        ) +
                                                                        "%)"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ])
                                                      : _vm._e()
                                                  }
                                                ),
                                                0
                                              ),
                                            ]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                  ]
                                : _vm._e(),
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        false
                          ? _c("div", { staticClass: "comments_block" }, [
                              _vm.sTasks[r.id]?.task_data?.comments &&
                              _vm.sTasks[r.id].task_data.comments.length
                                ? _c(
                                    "div",
                                    { staticClass: "comments card" },
                                    _vm._l(
                                      _vm.sTasks[r.id]?.task_data?.comments,
                                      function (c) {
                                        return _c(
                                          "div",
                                          { staticClass: "comment_message" },
                                          [
                                            _c("p", [_vm._v(_vm._s(c.text))]),
                                            _vm._v(" "),
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "text-muted text-right fs-10",
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(c.name || "Вы") +
                                                    " " +
                                                    _vm._s(
                                                      _vm.printDate(
                                                        c.created_at
                                                      )
                                                    )
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1 message_form" }, [
                                _c(
                                  "form",
                                  {
                                    on: {
                                      submit: function ($event) {
                                        $event.preventDefault()
                                        return (() =>
                                          _vm.updateTasks(
                                            _vm.sTasks[r.id]?.id,
                                            "comment"
                                          )).apply(null, arguments)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "input-group" }, [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.newComments[
                                                _vm.sTasks[r.id]?.id
                                              ],
                                            expression:
                                              "newComments[sTasks[r.id]?.id]",
                                          },
                                        ],
                                        staticClass: "form-control br-0",
                                        attrs: {
                                          type: "text",
                                          placeholder: "Комментарий",
                                          disabled:
                                            _vm.sendCommentLoading[
                                              _vm.sTasks[r.id]?.id
                                            ],
                                        },
                                        domProps: {
                                          value:
                                            _vm.newComments[
                                              _vm.sTasks[r.id]?.id
                                            ],
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) return
                                            _vm.$set(
                                              _vm.newComments,
                                              _vm.sTasks[r.id]?.id,
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "input-group-append" },
                                        [
                                          _c("LoadingButton", {
                                            attrs: {
                                              title: "Отправить",
                                              type: "submit",
                                              loading:
                                                _vm.sendCommentLoading[
                                                  _vm.sTasks[r.id]?.id
                                                ],
                                              color:
                                                _vm.$constants.LOADING_COLOR,
                                              onClick: () => {},
                                              className:
                                                "btn btn-outline-info br-0",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c("DrugsList", {
                          ref: `drugsList_${_vm.localTasks[r.id]?.id}`,
                          refInFor: true,
                          attrs: {
                            getActiveDrug: (drugData) => {},
                            drugLinks: _vm.drugLinks,
                            records: [r],
                            drugsTasks: [],
                            priceChanges: (_vm.localTasks[r.id] ?? []).reduce(
                              (acc, t) => {
                                acc.push(t.task)
                                return acc
                              },
                              []
                            ),
                            drugsOrdered: _vm.ordered,
                            invoices: _vm.invoices,
                            freezeInvoices: _vm.freezeInvoices,
                            ordersStat: _vm.ordersStat,
                            soldData: _vm.soldData,
                            storeDrugData: _vm.storeDrugData,
                            profitCalculation: _vm.profitCalculation,
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right mt-1 mr-1" },
                [
                  _vm.$can("updateDrugStatusPrices")
                    ? _c("LoadingButton", {
                        attrs: {
                          title: "Принять все изменения",
                          className: "btn btn-success",
                          onClick: () => _vm.acceptTask(-1, "accept"),
                          loading: _vm.btnLoading[-1],
                          color: _vm.$constants.SUCCESS_COLOR,
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }